import React from 'react';
import { useParams } from 'react-router-dom';
import QuoteAcceptForm from '../components/public/QuoteAcceptForm';

// ============================================================================
// QUOTE ACCEPT PAGE - Hosted at /quote/:token
// Customer-facing page for viewing and accepting quotes from email links
// ============================================================================

const QuoteAcceptPage = () => {
  const { token } = useParams();

  const handleAccepted = (data) => {
    // Optional: Track conversion in analytics
    if (window.gtag) {
      window.gtag('event', 'quote_accepted', {
        event_category: 'Quote',
        event_label: 'accepted',
        value: data.scheduledDate,
      });
    }
    
    // Optional: Facebook Pixel
    if (window.fbq) {
      window.fbq('track', 'Schedule', {
        content_name: 'quote_accepted',
      });
    }
  };

  return (
    <QuoteAcceptForm 
      token={token} 
      onAccepted={handleAccepted}
    />
  );
};

export default QuoteAcceptPage;